import classNames from "classnames"
import { useEffect, useRef, useState } from "react"
import colors from "styles/colors"
import css from "./Img.module.scss"

const Img = ({
  src,
  fallbackImg,
  width,
  height,
  alt = "",
  className,
  style = {},
}) => {
  const imgRef = useRef()
  const [opacity, setOpacity] = useState(0)
  const [imgSrc, setImgSrc] = useState(null)

  useEffect(() => {
    const imgEl = imgRef?.current

    if (!imgEl) return

    const observer = new IntersectionObserver(
      ([{ isIntersecting }]) => {
        if (isIntersecting && imgSrc === null) {
          setImgSrc(src)
        }
      },
      { threshold: [0.5] }
    )

    observer.observe(imgEl)

    // 👇️ remove the event listener when component unmounts
    return () => {
      observer.unobserve(imgEl)
    }
  }, [src, imgRef])

  return (
    <img
      ref={imgRef}
      src={imgSrc}
      alt={alt}
      onLoad={() => setOpacity(1)}
      onError={() => setImgSrc(fallbackImg)}
      className={classNames(css.img, className)}
      style={{ background: colors.white20, ...style, opacity }}
      width={width}
      height={height}
      referrerPolicy="no-referrer"
    />
  )
}

export default Img
